// Периоды графиков и работа с датами 'YYYY-MM-DD' в местном времени.

export type Period = 'week' | 'month' | '3m' | 'year' | 'all'

export const PERIODS: readonly { value: Period; label: string; days: number | null }[] = [
  { value: 'week', label: 'Неделя', days: 7 },
  { value: 'month', label: 'Месяц', days: 30 },
  { value: '3m', label: '3 мес', days: 91 },
  { value: 'year', label: 'Год', days: 365 },
  { value: 'all', label: 'Всё', days: null },
]

const pad = (n: number) => String(n).padStart(2, '0')

/** Местная дата в виде 'YYYY-MM-DD'. */
export function toIsoDate(date: Date): string {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

/** 'YYYY-MM-DD' → местная полночь. */
export function parseIsoDate(iso: string): Date {
  const [y, m, d] = iso.slice(0, 10).split('-').map(Number) as [number, number, number]
  return new Date(y, m - 1, d)
}

export function todayIso(): string {
  return toIsoDate(new Date())
}

export function addDays(iso: string, days: number): string {
  const date = parseIsoDate(iso)
  date.setDate(date.getDate() + days)
  return toIsoDate(date)
}

export function periodDays(period: Period): number | null {
  return PERIODS.find((p) => p.value === period)?.days ?? null
}

/** Диапазон периода, включая `today`. Для «Всё» начало — null. */
export function periodRange(period: Period, today: string = todayIso()): {
  start: string | null
  end: string
} {
  const days = periodDays(period)
  return { start: days === null ? null : addDays(today, -(days - 1)), end: today }
}
